export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7378.37eccb82.jpg";